import {cn} from '@/lib/utils';
import {useState} from 'react';
import {Button, ButtonProps} from '@/components/app/button';
import {Modal} from '@/components/app/modal';
import {useGetBiotwinSharesQuery} from '../../../app/services/biotwinShareApi';
import {Icon} from '../../../app/components/Icon';
import {useSession} from '../../auth/hooks/useSession';
import {BiotwinShareInfo} from './BiotwinShareInfo';
export interface BiotwinShareManagementButtonProps extends ButtonProps {
  biotwinId: number;
}
export const BiotwinShareManagementButton = ({biotwinId, ...otherProps}: BiotwinShareManagementButtonProps) => {
  const session = useSession();
  const [dialogVisible, setDialogVisible] = useState(false);
  const {data: biotwinShares = []} = useGetBiotwinSharesQuery();
  const existingBiotwinShares = biotwinShares.filter((biotwinShare) => biotwinShare.biotypeId === biotwinId);
  if (existingBiotwinShares.length === 0) {
    return null;
  }
  const incoming = existingBiotwinShares[0].ownerId !== Number(session?.id);
  return (
    <>
      <Button
        className={cn('', 'rounded-full')}
        {...otherProps}
        onClick={() => setDialogVisible(true)}
        variant="text"
        type="button"
      >
        <Icon icon={'users'} />
        <Icon className={'text-xs'} icon={incoming ? 'arrow-down' : 'arrow-up'} />
      </Button>
      <Modal
        title={'Biotwin Shares'}
        onClose={() => setDialogVisible(false)}
        style={{
          maxWidth: 'calc(100% - 3rem)',
          width: '40rem',
        }}
        open={dialogVisible}
      >
        {existingBiotwinShares.map((biotwinShare) => (
          <BiotwinShareInfo
            biotwinShare={biotwinShare}
            className={'border-b border-zinc-100 py-4'}
            key={biotwinShare.id}
          />
        ))}
      </Modal>
    </>
  );
};
